import { renderDate } from "@intrasync/utils";
import { ScheduleGridBodyCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";

interface ProductionScheduleLeftBodyCellProps
  extends ScheduleGridBodyCellProps {
  scheduleDate: string;
  rowCount: number;
  rowData: { entities: { moldNumber: string }[] };
}

const ProductionScheduleLeftBodyCell = (
  props: ProductionScheduleLeftBodyCellProps
) => {
  // console.log('LeftBody props', props);
  const {
    rowCount,
    scheduleDate,
    // rowData
  } = props;
  const backgroundColor = props.rowIndex % 2 === 0 ? "#f0f0f0" : "#e0e0e0";
  // const moldCount = rowData.entities.reduce(
  //   (acc: string[], entity: { moldNumber: string }) => {
  //     if (!acc.includes(entity.moldNumber)) {
  //       acc.push(entity.moldNumber);
  //     }

  //     return acc;
  //   },
  //   []
  // ).length;
  return (
    <div
      style={{
        ...props.style,
        ...props.styles,
        borderLeft: "1px solid #eee",
        borderRight: "1px solid #eee",
        borderTop: "1px solid #eee",
        borderBottom: "2px solid black",
        backgroundColor: backgroundColor,
        height: ((props?.style?.height as number) || 50) - 3,
      }}
    >
      <b>{renderDate(scheduleDate)}</b>
      {rowCount >= 1 && (
        <>
          <b>
            {rowCount} {rowCount === 1 ? "piece" : "pieces"}
          </b>
          {/* <b>
            {moldCount} {moldCount === 1 ? 'form' : 'forms'}
          </b> */}
        </>
      )}
    </div>
  );
};

export default ProductionScheduleLeftBodyCell;
